import React from 'react';
import { InputNumber, InputNumberProps } from 'antd';
import { useField, useFormikContext } from 'formik';

import FItem, { FItemProps } from './FItem';

type FItemInputNumberProps = InputNumberProps & {
  name: string;
  label?: string;
  formItemProps?: FItemProps;
  children?: React.ReactNode;
  StyledFItemWrapper?: React.ComponentType<FItemProps>;
};

const FItemInputNumber = ({
  name,
  label,
  formItemProps,
  children,
  StyledFItemWrapper: StyledFItem,
  ...props
}: FItemInputNumberProps) => {
  const formik = useFormikContext();
  const [field, meta] = useField(name);

  const FormItemWrapperComponent = StyledFItem || FItem;

  return (
    // PLA-9531: hasFeedback is pinned, not left to track validity. antd renders the feedback icon
    // by wrapping the control in an affix wrapper, so a validity-driven value ADDS and REMOVES a
    // DOM element around the input. Clearing a touched field flips valid -> error, the wrapper is
    // removed, and React unmounts the focused <input> with it - focus drops to BODY and every
    // keystroke after the first is swallowed, so a points outcome typed as "250" saves as 2.
    // Placed before the spread so a caller can still opt back in via formItemProps.
    <FormItemWrapperComponent
      meta={meta}
      label={label}
      htmlFor={name}
      hasFeedback={false}
      {...formItemProps}
    >
      <InputNumber
        id={name}
        {...field}
        onChange={val => formik.setFieldValue(name, val)}
        onBlur={() => formik.setFieldTouched(name)}
        {...props}
      />
      {children}
    </FormItemWrapperComponent>
  );
};

export default FItemInputNumber;
